import { useEffect } from 'react'
import { useToastStore, type Toast } from '@/store/toastStore'

const toneStyles: Record<Toast['tone'], string> = {
  info: 'border-border text-text',
  error: 'border-critDim text-crit bg-crit/10',
  success: 'border-accentDim text-accent bg-accent/10',
}

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
    </div>
  )
}

function ToastItem({ toast, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 5000)
    return () => clearTimeout(timer)
  }, [onDismiss])

  return (
    <div
      role="status"
      className={`rounded-md border bg-surface px-3.5 py-2.5 text-xs shadow-lg ${toneStyles[toast.tone]}`}
    >
      {toast.message}
    </div>
  )
}

export const toast = {
  success: (msg: string) => useToastStore.getState().push(msg, 'success'),
  error: (msg: string) => useToastStore.getState().push(msg, 'error'),
  info: (msg: string) => useToastStore.getState().push(msg, 'info'),
}
